import { EMAIL_SYNTAX, ZIPCODE_SYNTAX } from '../constants/regex'

/** Shared field validators. Single source for email/zip/phone/DOB checks. */

const MINIMUM_ADULT_AGE = 18
const PHONE_DIGITS = 10

export const isValidEmail = (value?: string | null): boolean =>
  typeof value === 'string' && EMAIL_SYNTAX.test(value.trim())

/** US ZIP: 5 digits. */
export const isValidZipCode = (value?: string | null): boolean =>
  typeof value === 'string' && ZIPCODE_SYNTAX.test(value.trim())

/** US phone: 10 digits after stripping non-numerics. */
export const isValidPhone = (value?: string | null): boolean =>
  typeof value === 'string' && value.replace(/\D/g, '').length === PHONE_DIGITS

/** DOB is at least 18 as of `now` (injectable for tests). Accepts ISO string or Date. */
export const dobAtLeast18 = (
  dob: string | Date | undefined | null,
  now: Date = new Date()
): boolean => {
  if (!dob) return false

  const birth = dob instanceof Date ? dob : new Date(`${dob}T00:00:00`)
  if (Number.isNaN(birth.getTime())) return false
  if (birth.getTime() > now.getTime()) return false

  let age = now.getFullYear() - birth.getFullYear()
  const monthDelta = now.getMonth() - birth.getMonth()
  const beforeBirthday =
    monthDelta < 0 || (monthDelta === 0 && now.getDate() < birth.getDate())
  if (beforeBirthday) age -= 1

  return age >= MINIMUM_ADULT_AGE
}
